import React from "react";

// import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
// import { NavLink } from "react-router-dom";
import { Box, Menu, Container, MenuItem, Avatar, Tooltip } from "@mui/material";
import AdbIcon from "@mui/icons-material/Adb";
import IconButton from "@mui/material/IconButton";
// import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
// import Tooltip from "@mui/material/Tooltip";
import MenuIcon from "@mui/icons-material/Menu";

import { styled, useTheme } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import { Link, NavLink, useNavigate } from "react-router-dom";
import logo from "../assets/Top Neighborhood Pros-03.png";
import HomeIcon from "@mui/icons-material/Home";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import LoginIcon from "@mui/icons-material/Login";
import { useSelector } from "react-redux";
import { useLogoutUserMutation } from "../services/apiSlice";
import LogoutIcon from "@mui/icons-material/Logout";
import DashboardIcon from "@mui/icons-material/Dashboard";
const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));
const Header = ({ open, setOpen }) => {
  const navigate = useNavigate();
  const [logoutUser, { isLoading }] = useLogoutUserMutation();
  const userSignIn = useSelector((state) => state?.userSignIn);
  const { userInfo } = userSignIn;
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  // const [anchorElUser, setAnchorElUser] = React.useState(null);
  const theme = useTheme();
  // const [open, setOpen] = React.useState(false);
  const handleLogout = async () => {
    const logout = await logoutUser();
    console.log({ logout });
    if (logout?.data?.success === true) {
      navigate("/");
      console.log("logout success");
    }
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  // const handleOpenUserMenu = (event) => {
  //   setAnchorElUser(event.currentTarget);
  // };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  // const handleCloseUserMenu = () => {
  //   setAnchorElUser(null);
  // };
  return (
    <Box sx={{ display: "flex", marginBottom: 20 }}>
      {/* <CssBaseline /> */}
      <AppBar
        position="fixed"
        className="bg-white  text-center text-black"
        open={open}
      >
        <Toolbar>
          <Box sx={{ display: { xs: "block", md: "none" } }} className="ml-4">
            {/* <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon /> */}

            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                mr: 2,
                ...(open && { display: "none" }),
              }}
            >
              <MenuIcon />
            </IconButton>
          </Box>
          <Avatar
            alt="Top Neigbourhood pro"
            variant={"rounded"}
            className="lg:ml-20  text-black "
            sx={[
              { width: "12%", height: "12%" },
              (theme) => ({
                [theme.breakpoints.down("sm")]: {
                  px: 1,
                  width: "40%",
                  height: "40%",
                },
              }),
              (theme) => ({
                [theme.breakpoints.down("md")]: {
                  px: 1,
                  width: "25%",
                  height: "25%",
                },
              }),
            ]}
            src={logo}
          />
          {/* <Typography
            variant="h6"
            className="lg:pl-20 text-black "
            noWrap
            component="div"
          >
            Persistent drawer
          </Typography> */}

          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex" },
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
            className=" text-black"
          >
            <Button
              component={NavLink}
              to={`/`}
              className="hover:bg-green-300"
              sx={{
                my: 2,
                fontWeight: "bold",
                color: "black",
                display: "block",
                px: 3,
                textAlign: "center",
              }}
            >
              <IconButton>
                <HomeIcon />
              </IconButton>
              Home
            </Button>{" "}
            <Button
              component={NavLink}
              to={`/`}
              className="hover:bg-green-300"
              sx={{
                my: 2,
                fontWeight: "bold",
                color: "black",
                display: "block",
                px: 3,
                textAlign: "center",
              }}
            >
              <IconButton>
                <HomeIcon />
              </IconButton>
              Contact Us
            </Button>{" "}
            <Button
              component={NavLink}
              to={`/`}
              className="hover:bg-green-300"
              sx={{
                my: 2,
                fontWeight: "bold",
                color: "black",
                display: "block",
                px: 3,
                textAlign: "center",
              }}
            >
              <IconButton>
                <HomeIcon />
              </IconButton>
              About Us
            </Button>
            {userInfo !== undefined ? (
              <>
                <Tooltip title="Logout">
                  <Button onClick={() => handleLogout()}>
                    <IconButton
                      sx={[
                        // { px: 3 },
                        (theme) => ({
                          [theme.breakpoints.up("321")]: {
                            // display: "none",
                          },
                        }),
                      ]}
                    >
                      <LogoutIcon />
                    </IconButton>{" "}
                    Logout
                  </Button>
                </Tooltip>
                <Button
                  component={NavLink}
                  className="hover:bg-green-300"
                  to={`/dashboard`}
                  sx={{
                    my: 2,
                    fontWeight: "bold",
                    color: "black",
                    display: "block",
                    px: 3,
                  }}
                >
                  {" "}
                  <IconButton>
                    <DashboardIcon />
                  </IconButton>
                  Dashboard
                </Button>
              </>
            ) : (
              <>
                <Button
                  component={NavLink}
                  className="hover:bg-green-300"
                  to={`/login`}
                  sx={{
                    my: 2,
                    fontWeight: "bold",
                    color: "black",
                    display: "block",
                    px: 3,
                  }}
                >
                  <IconButton>
                    <LoginIcon />
                  </IconButton>
                  Sign In/Login
                </Button>
                <Button
                  component={NavLink}
                  className="hover:bg-green-300"
                  to={`/register`}
                  sx={{
                    my: 2,
                    fontWeight: "bold",
                    color: "black",
                    display: "block",
                    px: 3,
                  }}
                >
                  {" "}
                  <IconButton>
                    <AppRegistrationIcon />
                  </IconButton>
                  Register
                </Button>
              </>
            )}
            {/* <Button
               component={NavLink}
              to={`/sermon`}
              sx={{
                my: 2,
                fontWeight: "bold",
                color: "white",
                display: "block",
              }}
            >
              Sermon
            </Button> */}
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
        variant="temporary"
        anchor="left"
        open={open}
        // onClose={handleDrawerClose(anchor, false)}
      >
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "ltr" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          <Link to={"/"}>
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <HomeIcon />
                </ListItemIcon>{" "}
                <ListItemText primary={" Home"} />
              </ListItemButton>
            </ListItem>
          </Link>
          <Link to={"/"}>
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <HomeIcon />
                </ListItemIcon>{" "}
                <ListItemText primary={" Contact Us"} />
              </ListItemButton>
            </ListItem>
          </Link>
          <Link to={"/"}>
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <HomeIcon />
                </ListItemIcon>{" "}
                <ListItemText primary={" About Us"} />
              </ListItemButton>
            </ListItem>
          </Link>

          {userInfo !== undefined ? (
            <>
              <Tooltip title="Logout">
                <Button onClick={() => handleLogout()}>
                  <ListItem disablePadding>
                    <ListItemButton>
                      <ListItemIcon>
                        <LogoutIcon />
                      </ListItemIcon>
                      <ListItemText primary={"Logout"} />
                    </ListItemButton>
                  </ListItem>
                </Button>
              </Tooltip>

              <Link to={"/dashboard"}>
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <DashboardIcon />
                    </ListItemIcon>
                    <ListItemText primary={"Dashboard"} />
                  </ListItemButton>
                </ListItem>
              </Link>
            </>
          ) : (
            <>
              <Link to={"/register"}>
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <AppRegistrationIcon />
                    </ListItemIcon>
                    <ListItemText primary={"Register"} />
                  </ListItemButton>
                </ListItem>
              </Link>
              <Link to={"/login"}>
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <LoginIcon />
                    </ListItemIcon>
                    <ListItemText primary={"Sign In"} />
                  </ListItemButton>
                </ListItem>
              </Link>
            </>
          )}
        </List>
        <Divider />
        {/* <List>
          {["All mail", "Trash", "Spam"].map((text, index) => (
            <ListItem key={text} disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List> */}
      </Drawer>
    </Box>
  );
};

export default Header;
